<template>
    <span>
        <rechargeDialog v-if="showRechargeDialog" @close="showRechargeDialog=false"></rechargeDialog>
        <rechargeHistoryDialog v-if="showRechargeHisDialog" @close="showRechargeHisDialog=false"></rechargeHistoryDialog>
        <balanceHistoryDialog v-if="showBalanceHisDialog" @close="showBalanceHisDialog=false"></balanceHistoryDialog>

        <el-popover placement="left-start" width="300" trigger="hover" @show="onShow">
            <div class="cost">
                <el-row type="flex" align="middle" justify="space-between">
                    <p>账户余额</p>
                    <el-button type="text" @click="showRechargeDialog=true">立即充值</el-button>
                </el-row>
                <el-row style="font-size: 24px">{{balanceAmount}}元</el-row>
                <el-button type="text" class="cost-item" @click="showRechargeHisDialog=true">
                    <i class="el-icon-"></i>
                    充值记录
                </el-button>
                <el-button type="text" class="cost-item" @click="showBalanceHisDialog=true">
                    <i class="el-icon-"></i>
                    消费记录
                </el-button>
            </div>
            <el-button type="text" slot="reference">
                费用信息
                <i class="el-icon-caret-bottom"></i>
            </el-button>
        </el-popover>

    </span>
</template>
<script>
import rechargeDialog from "./rechargeDialog";
import rechargeHistoryDialog from "./rechargeHistoryDialog";
import balanceHistoryDialog from "./balanceHistoryDialog";

export default {
    components: {
        rechargeDialog,
        balanceHistoryDialog,
        rechargeHistoryDialog
    },
    data() {
        return {
            balanceAmount: null,
            showRechargeDialog: false,
            showRechargeHisDialog: false,
            showBalanceHisDialog: false,
        }
    },
    methods: {
        queryBalance() {
            this.$API.queryBalance({}).then((response) => {
                if (response.code == 0 || response.code == 1000) {
                    this.balanceAmount = response.data;
                }
            });
        },
        onShow() {
            this.queryBalance();
        },
    }
}
</script>
<style scoped lang="scss">
.cost {

    // width:200px;
    .cost-item {
        width: 100%;
        cursor: pointer;
        text-align: left;
        margin: 0;
        // height: 40px;
        // line-height: 40px;
        font-size: 14px;
    }

    .cost-item:hover {
        background: #f0f3f4;
    }
}
</style>